import { useEffect, useCallback, useRef } from 'react';
import styles from './index.module.scss'
import Utils from '@utils/utils';
import { CheckSquareFilled } from '@ant-design/icons';
import { BATCH_IMAGES_TYPE, IMAGE_TYPE } from '@utils/CONST';

const sortSucceededTasks = (tasks = []) => {
    const succeededTasks = (tasks || []).filter(task => task.status === "succeeded");
    const isSmartDetailTask = succeededTasks.some(task => task?.projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH || task?.imageType === IMAGE_TYPE.SMART_DETAILA_PAGE)
    if (!isSmartDetailTask) return succeededTasks

    return succeededTasks
        .map((task, index) => ({ task, index }))
        .sort((a, b) => {
            const aSortIdx = Number(a?.task?.attr?.sortIdx ?? a?.task?.sortIdx)
            const bSortIdx = Number(b?.task?.attr?.sortIdx ?? b?.task?.sortIdx)
            const aValue = Number.isFinite(aSortIdx) ? aSortIdx : Number.MAX_SAFE_INTEGER
            const bValue = Number.isFinite(bSortIdx) ? bSortIdx : Number.MAX_SAFE_INTEGER
            if (aValue !== bValue) return aValue - bValue
            return a.index - b.index
        })
        .map(({ task }) => task)
}

const PicModalRight = (props) => {
    const { groupedTasks, taskId } = props
    const containerRef = useRef(null);
    const selectedItemRef = useRef(null);
    const debounceRef = useRef({ lastExecution: 0, delay: 200 }); // 200ms 防抖延迟

    const currentTaskGroup = (groupedTasks || []).find(group => (group || []).some(task => task?.taskId === taskId))
    const succeededTasks = sortSucceededTasks(currentTaskGroup || []);
    const currentIndex = succeededTasks.findIndex(task => task.taskId === taskId);

    const handleKeyDown = useCallback((event) => {
        if (succeededTasks.length === 0) return;

        // 防抖
        const now = Date.now();
        const { lastExecution, delay } = debounceRef.current;

        if (now - lastExecution < delay) {
            event.preventDefault();
            return;
        }

        debounceRef.current.lastExecution = now;

        let newIndex = currentIndex;

        if (event.key === 'ArrowUp') {
            newIndex = currentIndex > 0 ? currentIndex - 1 : 0;
            event.preventDefault();
        } else if (event.key === 'ArrowDown') {
            newIndex = currentIndex < succeededTasks.length - 1 ? currentIndex + 1 : succeededTasks.length - 1;
            event.preventDefault();
        }

        if (newIndex !== currentIndex && succeededTasks[newIndex]) {
            props.setTaskId(succeededTasks[newIndex].taskId);
        }
    }, [currentIndex, succeededTasks, props]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    // 滚动选中项到可视区域
    useEffect(() => {
        if (selectedItemRef.current && containerRef.current) {
            selectedItemRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
            });
        }
    }, [taskId]);

    return (
        <div ref={containerRef} className={`${styles.PicModalRight} _beauty_scrollbar`}>
            {
                succeededTasks.map((task, index) => (
                    <div key={task?.taskId || index} className={`${styles.itemWrap} ${taskId == task?.taskId ? styles.active : ''}`}>
                        {task?.results?.[0]?.picked && <CheckSquareFilled className={styles.checkIcon} />}
                        <img
                            ref={taskId == task?.taskId ? selectedItemRef : null}
                            onClick={() => props.setTaskId(task?.taskId)}
                            src={task?.projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ?
                                Utils.getImgThumbnail(task?.inputImages?.[0]?.url) :
                                Utils.getImgThumbnail(task?.results?.[0]?.image)} alt="" />
                    </div>

                ))
            }
        </div>
    )
}

export default PicModalRight
